<template>
    <div class="view pa24">
        <el-dialog :title="title" width="800px" :modal-append-to-body="false" :visible.sync="dialogVisible"
            :close-on-click-modal="false" :before-close="closeDialog">
            <el-form :model="ruleForm" :rules="rules" ref="dealerRuleForm" label-width="100px" class="ruleForm">
                <el-form-item label="所属公司选择" prop="devices">
                    <el-select v-model="ruleForm.companyId" placeholder="请选择所属公司">
                        <el-option v-for="company in companyList" :key="company.companyId" :label="company.companyName"
                            :value="company.companyId" />
                    </el-select> 
                </el-form-item>
                <el-form-item label="上传文件" >
                <!-- <comm-upload-file :files="ruleForm.file"></comm-upload-file> -->
                <el-upload class="upload-demo" :action="uploadUrl" :headers="upParams" :on-success="handleSuccess"
                    :limit="1" :on-remove="handleRemove" :before-upload="beforeUpload" :on-exceed="handleExceed"
                    :show-file-list="true" :file-list="fileList">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传xlsx/xls文件</div>
                </el-upload>
            </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button class="btncss" @click="confirmAddDealer">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { company, importExcel } from '@/api/gps.js'
    import CommUploadFile from "@/components/CommUploadFile.vue";
    export default { 
        data() {  
            let token = localStorage.getItem("token")
            return {
                fileList: [],
                upParams: {
                    token: token
                },
                uploadUrl: this.$store.state.uploadingExcle,
                dialogVisible: false,
                title: '设备导入',
                components: {
                    // BaiduMap,
                    CommUploadFile
                },

                ruleForm: {
                    companyId: '',
                    file: null
                },
                rules: {
                    recycle: [
                        { required: true, message: '请输入设备号', trigger: 'blur' }
                    ]
                },
                companyList: [],
                fileForm: ''
            };
        },
        methods: {
            openDialog(type, data) {
                this.ruleForm = {};
                this.getCompanyList()
                this.dialogVisible = true
            },
            closeDialog() {
                this.dialogVisible = false;
            },
            confirmAddDealer() {
                this.$refs.dealerRuleForm.validate((valid) => {
                    if (valid) {
                        // 构建params
                        let formData = new FormData();
                        formData.append('companyId', this.ruleForm.companyId);
                        formData.append('file', this.ruleForm.fileForm);
                        importExcel(formData).then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '设置成功'
                                })
                                this.closeDialog()
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            getCompanyList() {
                company().then(res => {
                    if (res.code == 200) {
                        this.companyList = res.data
                    }
                })
            },
            // 上传文件
            handleSuccess(response, file, fileList) {
                console.log(file)
                if (response.code === 200) {
                    this.fileList = fileList
                    this.ruleForm.file = file.raw
                    this.ruleForm.fileForm = file.raw
                } else {
                    this.$message.error(response.message)
                    this.fileList = []
                }
            },
            handleRemove(file, fileList) {
                this.fileList = fileList
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${file.name}？`);
            },
            beforeUpload(file) {
                // 允许上传的文件格式列表
                let acceptList = ["xlsx", "xls"]
                // 根据文件名获取文件的后缀名
                let fileType = file.name.split('.').pop().toLowerCase()
                // 判断文件格式是否符合要求
                if (acceptList.indexOf(fileType) === -1) {
                    this.$message.error('只能上传 xlsx/xls 格式的文件 !');
                    return false
                }
            },
        }
    };

</script>